export const TicketTableReceivingColumns = [
  { key: 'created', sortable: true },
  { key: 'client', sortable: true },
  { key: 'statusChangedAt', sortable: true },
];

export const TicketTableTransferringColumns = [
  { key: 'transferringIban' },
  { key: 'created', sortable: true },
  { key: 'statusChangedAt', sortable: true },
  { key: 'accountCloseDeadline', sortable: true },
];

export const TicketTablePagination = {
  itemsByPage: 10,
  displayedPages: 5,
};

export const TicketTableFilterModifier = {
  status: {
    translate: true,
    translatePrefix: 'app.ticket.status.',
    translated: {},
  },
  transferringIban: {
    ignoreWhitespace: true,
  },
  receivingIban: {
    ignoreWhitespace: true,
  },
};
